import {Button} from "react-bootstrap";
import {useCallback, useContext, useMemo, useRef, useState} from "react";
import AppContext from "../AppContext";
import VideoJS from './VideoJS'
import './CategoryVideo.scss';
import {PiVideoCameraSlashDuotone} from "react-icons/pi";
import {useTranslation} from "react-i18next";

export default function ExtraVideoPlayer({ video, closeVideo, onVideoWatched }) {
    const app = useContext(AppContext)
    const { t, i18n } = useTranslation();
    const [videoPlayed, setVideoPlayed] = useState(false)
    const [videoError, setVideoError] = useState(-1)

    const playerRef = useRef(null);

    //const videoSrc = 'https://cdn.theorieflix.nl/vt/' + video.video_id + '.mp4'
    const videoSrc = 'https://cdn.theorieflix.nl/videos/new-examq/' + video.video_id + '.mp4'
    const videoJsOptions = useMemo(() => ({

        autoplay: !videoPlayed,

        controls: true,

        responsive: true,

        playsinline: true,

        fluid: true,

        poster: 'https://cdn.theorieflix.nl/videos/poster.jpg',

        sources: [{

            src: videoSrc,

            type: 'video/mp4'

        }]

    }), [videoSrc]);

    const watchedSeconds = useRef(0);
    const lastTime = useRef(0);
    const watched10Seconds = useRef(false);

    const replayVideo = () => {
        const player = playerRef.current;
        if (!player) return;
        setVideoPlayed(false);
        player.currentTime(0);
        player.play();
    };
    const handlePlayerReady = useCallback((player) => {
        playerRef.current = player;

        // You can handle player events here, for example:
        player.on('waiting', () => {

        });

        player.on('error', () => {
            const err = player.error();
            setVideoError(err.code)
            if(err.code >= 2) {
                //report video error
            }
        })
        player.on('dispose', () => {

        });
        player.on('ended', () => {
            try {
                if(player.isFullscreen())
                    player.exitFullscreen()
            }
            catch(e) {

            }
            onVideoPlayed()
        });
        player.on('pause', () => {

        });

        player.on('play', () => {

            lastTime.current = player.currentTime();

        });

        player.on('timeupdate', () => {

            const current = player.currentTime();

            // Ignore large jumps (seeking)

            const diff = current - lastTime.current;

            if (diff > 0 && diff < 2) {

                watchedSeconds.current += diff;

            }

            lastTime.current = current;

            if (

                !watched10Seconds.current &&

                watchedSeconds.current >= 5

            ) {

                watched10Seconds.current = true;
                if(!video.watched)
                    onVideoWatched()
                //console.log('Actually watched 5 seconds');
            }

        });
    }, [])

    const onVideoPlayed = async () => {
        setVideoPlayed(true)
    }

    return <div className={'category-video-wrapper'}>
        {videoError < 0 && <div className="category-video">
            <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
        </div>}
        {videoError >= 0 && <div className="category-video-error">
            <h1 className="mb-4 title"><PiVideoCameraSlashDuotone size="38" className="me-3" /> {t('videoError.title')}</h1>
            <p>
                <p className="video-error-details">
                    Error Code: {videoError} &nbsp; &nbsp; | &nbsp; &nbsp; App Version: {process.env.REACT_APP_VERSION}
                </p>
                {t('videoError.text1')}
                <br />
                {t('videoError.text2')}
                <br />
                <br />
                <strong>
                    {t('videoError.text3')}
                    <br />
                    <br />
                    {t('videoError.text4')}
                </strong>
            </p>
        </div>}
        <div className="category-video-buttons pt-4 text-center">
            {(videoPlayed || videoError >= 0) && <Button onClick={replayVideo} variant="success">{t('quiz.replayVideo')}</Button>}
            &nbsp;
            {(videoPlayed || videoError >= 0) && <Button onClick={closeVideo} variant="secondary">{t('button.continue')}</Button>}
        </div>
    </div>
}